import { GAUGE_DEFAULT_CONFIG } from '../constants.js';
import type { GaugeChartConsumerConfig } from '../types/gauge-chart-config.js';

export const deserializeConfig = (
  serializedConfig: string,
): GaugeChartConsumerConfig => {
  try {
    return JSON.parse(serializedConfig);
  } catch {
    return GAUGE_DEFAULT_CONFIG;
  }
};
